import { useState } from 'react';
import {
  ShoppingBag, CheckCircle2,
  Map, Truck, Users, UserCircle, List,
  LogOut, Menu, X, RefreshCw, Wallet, RotateCcw, BarChart2, PhoneCall, TrendingUp, CalendarDays, Archive, ShieldAlert, ClipboardCheck, BookOpen, FileUser,
} from 'lucide-react';

const navAdmin = [
  { section: 'Opérations' },
  { id: 'commandes',     icon: ShoppingBag,  label: 'À traiter',    badge: 'pending' },
  { id: 'confirmations', icon: CheckCircle2, label: 'Confirmées' },
  { id: 'expedition',    icon: Truck,        label: 'Expédition' },
  { id: 'fermeture',     icon: PhoneCall,    label: 'Fermeture',    badge: 'closing' },
  { id: 'retours',       icon: RotateCcw,    label: 'Retours',      badge: 'failed' },
  { section: 'Suivi' },
  { id: 'livraisons',    icon: List,         label: 'Livraisons' },
  { id: 'carte',         icon: Map,          label: 'Carte GPS' },
  { section: 'Finance' },
  { id: 'versements',    icon: Wallet,       label: 'Versements' },
  { id: 'finances',      icon: TrendingUp,   label: 'Finances' },
  { id: 'bilans',        icon: BarChart2,    label: 'Bilans' },
  { section: 'Admin' },
  { id: 'presences',     icon: ClipboardCheck, label: 'Présences',      muted: true },
  { id: 'audit',         icon: ShieldAlert,  label: 'Audit',          muted: true },
  { id: 'stock',         icon: Archive,      label: 'Stock livreurs', muted: true },
  { id: 'planning',      icon: CalendarDays, label: 'Planning',       muted: true },
  { id: 'equipe',        icon: Users,        label: 'Équipe',         muted: true },
  { id: 'users',         icon: UserCircle,   label: 'Utilisateurs',   muted: true },
  { id: 'candidatures',  icon: FileUser,     label: 'Candidatures',   muted: true },
  { section: 'Équipe' },
  { id: 'reglement',    icon: BookOpen,     label: 'Règlement',      muted: true },
];

const navGestionnaire = [
  { section: 'Opérations' },
  { id: 'commandes',     icon: ShoppingBag,    label: 'À traiter',    badge: 'pending' },
  { id: 'confirmations', icon: CheckCircle2,   label: 'Confirmées' },
  { id: 'expedition',    icon: Truck,          label: 'Expédition' },
  { id: 'retours',       icon: RotateCcw,      label: 'Retours',      badge: 'failed' },
  { section: 'Suivi' },
  { id: 'livraisons',    icon: List,           label: 'Livraisons' },
  { id: 'carte',         icon: Map,            label: 'Carte GPS' },
  { id: 'traitees',      icon: Archive,        label: 'Traitées' },
  { section: 'Finance' },
  { id: 'versements',    icon: Wallet,         label: 'Versements' },
  { section: 'Équipe' },
  { id: 'reglement',     icon: BookOpen,       label: 'Règlement' },
];

export default function Sidebar({ activeNav, onNavigate, onLogout, onRefresh, pendingCount = 0, failedCount = 0, closingCount = 0, role = 'admin', userName, userInitials, onSwitchToDriver }) {
  const [isOpen, setIsOpen] = useState(false);

  const nav = role === 'gestionnaire' ? navGestionnaire : navAdmin;
  const displayName = userName || (role === 'gestionnaire' ? 'Gestionnaire' : 'Administrateur');
  const displayInitials = userInitials || (role === 'gestionnaire' ? 'G' : 'A');

  const handleNavigate = (id, soon) => {
    if (soon) return;
    onNavigate(id);
    setIsOpen(false);
  };

  const SidebarContent = () => (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>

      {/* Header : profil + bouton fermer */}
      <div style={{ padding: '14px 14px 12px', borderBottom: '1px solid rgba(255,255,255,0.07)', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '12px', background: 'linear-gradient(135deg, #c53a2d, #7a1810)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 4px 12px rgba(197,58,45,0.4)' }}>
            <span style={{ fontSize: '16px', fontWeight: 800, color: 'white', fontFamily: 'Alan Sans, sans-serif' }}>{displayInitials}</span>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: 700, color: 'white', marginBottom: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{displayName}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#22c55e', fontWeight: 600 }}>
              <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 5px rgba(34,197,94,0.8)' }} />
              En ligne
            </div>
          </div>
          {onRefresh && (
            <button onClick={onRefresh} title="Actualiser"
              style={{ width: '28px', height: '28px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s', flexShrink: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.14)'; e.currentTarget.style.color = 'white'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = 'rgba(255,255,255,0.55)'; }}>
              <RefreshCw size={12} />
            </button>
          )}
          <button className="md-hide" onClick={() => setIsOpen(false)}
            style={{ width: '28px', height: '28px', borderRadius: '8px', background: 'rgba(255,255,255,0.08)', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <X size={14} />
          </button>
        </div>
      </div>

      {/* Navigation scrollable */}
      <nav style={{ flex: 1, padding: '6px 10px', overflowY: 'auto' }}>
        {nav.map((item, i) => {
          if (item.section) {
            return (
              <div key={i} style={{ padding: '14px 10px 5px', fontSize: '10px', color: 'rgba(255,255,255,0.28)', textTransform: 'uppercase', letterSpacing: '1.8px', fontWeight: 700 }}>
                {item.section}
              </div>
            );
          }
          const isActive = activeNav === item.id;
          const Icon = item.icon;
          const isMuted = item.muted && !isActive;
          return (
            <button key={item.id} onClick={() => handleNavigate(item.id, item.soon)}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
                padding: isMuted ? '7px 12px' : '9px 12px',
                fontSize: isMuted ? '12px' : '13px',
                fontWeight: isActive ? 700 : 500,
                borderRadius: '10px', border: 'none', cursor: 'pointer',
                background: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                color: isActive ? '#ffffff' : isMuted ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.6)',
                transition: 'all 0.15s', outline: 'none', textAlign: 'left', marginBottom: '1px',
                boxShadow: isActive ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none',
              }}
              onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = 'rgba(255,255,255,0.9)'; } }}
              onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = isActive ? '#fff' : isMuted ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.6)'; } }}
            >
              <div style={{ width: isMuted ? '26px' : '30px', height: isMuted ? '26px' : '30px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: isActive ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.05)', transition: 'background 0.15s' }}>
                <Icon size={isMuted ? 13 : 15} />
              </div>
              <span style={{ flex: 1 }}>{item.label}</span>
              {item.badge === 'pending' && pendingCount > 0 && (
                <span style={{ fontSize: '10px', fontWeight: 800, padding: '2px 7px', borderRadius: '20px', background: '#ef4444', color: 'white', minWidth: '20px', textAlign: 'center', boxShadow: '0 2px 6px rgba(239,68,68,0.5)' }}>
                  {pendingCount}
                </span>
              )}
              {item.badge === 'closing' && closingCount > 0 && (
                <span style={{ fontSize: '10px', fontWeight: 800, padding: '2px 7px', borderRadius: '20px', background: '#c53a2d', color: 'white', minWidth: '20px', textAlign: 'center', boxShadow: '0 2px 6px rgba(197,58,45,0.45)' }}>
                  {closingCount}
                </span>
              )}
              {item.badge === 'failed' && failedCount > 0 && (
                <span style={{ fontSize: '10px', fontWeight: 800, padding: '2px 7px', borderRadius: '20px', background: '#c2410c', color: 'white', minWidth: '20px', textAlign: 'center', boxShadow: '0 2px 6px rgba(194,65,12,0.5)' }}>
                  {failedCount}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Déconnexion — toujours visible en bas */}
      <div style={{ padding: '10px 12px', borderTop: '1px solid rgba(255,255,255,0.07)', flexShrink: 0 }}>
        {onSwitchToDriver && (
          <button onClick={onSwitchToDriver}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', borderRadius: '10px', border: '1px solid rgba(109,40,217,0.4)', background: 'rgba(109,40,217,0.15)', color: '#c4b5fd', fontSize: '13px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s', marginBottom: '8px' }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(109,40,217,0.28)'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(109,40,217,0.15)'; e.currentTarget.style.color = '#c4b5fd'; }}>
            <Truck size={14} /> Mode Livreur
          </button>
        )}
        <button onClick={onLogout}
          style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.07)', background: 'transparent', color: 'rgba(255,255,255,0.45)', fontSize: '13px', fontWeight: 500, cursor: 'pointer', transition: 'all 0.15s' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,68,68,0.1)'; e.currentTarget.style.color = '#fca5a5'; e.currentTarget.style.borderColor = 'rgba(239,68,68,0.25)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; }}>
          <LogOut size={14} /> Se déconnecter
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Topbar mobile */}
      <div className="md-hide" style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', height: '64px',
        background: 'linear-gradient(90deg, #07162d 0%, #112c52 100%)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '0 2px 16px rgba(0,0,0,0.25)',
      }}>
        <button onClick={() => setIsOpen(!isOpen)}
          style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.08)', border: 'none', cursor: 'pointer', color: 'white', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.15s', flexShrink: 0 }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
          {isOpen ? <X size={18} /> : <Menu size={18} />}
        </button>
        <img src="/logo-wakaana.png" alt="Wakaana Express"
          style={{ height: '68px', maxWidth: '180px', objectFit: 'contain' }} />
        <div style={{ width: 36 }} />
      </div>

      {/* Overlay mobile — couvre TOUT y compris la bottom nav */}
      {isOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1001, background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(4px)' }}
          onClick={() => setIsOpen(false)} />
      )}

      {/* Sidebar — au-dessus de l'overlay et de la bottom nav */}
      <aside className={`md-sidebar${isOpen ? ' sidebar-open' : ''}`} style={{
        position: 'fixed', left: 0, top: 0, height: '100vh', width: '240px',
        zIndex: 1002,
        background: 'linear-gradient(180deg, #07162d 0%, #0d1e3d 50%, #112040 100%)',
        borderRight: '1px solid rgba(255,255,255,0.05)',
        transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
        boxShadow: '4px 0 32px rgba(0,0,0,0.35)',
        overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
      }}>
        <SidebarContent />
      </aside>
    </>
  );
}
